/**
 * Catalyst Link adapted for Next.js — wraps next/link so Catalyst
 * components that use `<Link>` get client-side transitions automatically.
 *
 * Based on the Catalyst docs' Next.js integration example.
 */

import * as Headless from "@headlessui/react";
import NextLink, { type LinkProps } from "next/link";
import React, { forwardRef } from "react";

export const Link = forwardRef(function Link(
  props: LinkProps & React.ComponentPropsWithoutRef<"a">,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  return (
    <Headless.DataInteractive>
      <NextLink {...props} ref={ref} />
    </Headless.DataInteractive>
  );
});
